export const ASSET_STATUS = {
  SOLD: 2,
  WAREHOUSE: 1,
  CANCEL: 3,
  ARCHIVE: 4,
  ACTIVE: 5,
  IN_TRANSIT: 6,
  ON_ORDER: 7,
  DISCARDED: 8,
  STOLEN: 9,
};
